export const enumsConstants = {
  ENUMS: 'ENUMS'
};

export const mainCialCountries = ['ARG', 'BRA', 'MEX', 'PRY', 'PER', 'URY'];